import React from 'react';
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { LOGIN_PAGE } from "../../configuration/paths";
import { getVehicles } from "../../store";
import { useEffect } from "react"
import { sortBy } from "lodash";
import useIsMobile from '../../hooks/useIsMobile';
import DashboardDesktop from './DashboardDesktop';
import DashboardMobile from './DashboardMobile';


const Index = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loggedIn = !!useSelector(state => state.app.auth.token)
    const vehicles = useSelector(state => state.app.vehicles)

    const [loading, setLoading] = useState(true);
    const [selectedUnitID, setSelectedUnitID] = useState('');
    const [mapCoord, setMapCoord] = useState([39.0048687, -77.4303391780082]);
    const [filter, setFilter] = useState('All');

    const isMobile = useIsMobile();

    const handleMarkerClick = (item) => {
        setSelectedUnitID(item[0])
        setMapCoord([item[1], item[2]])
    }

    const checkOnlineStatus = (last_seen, status) => {
        let now = new Date();
        const last_date = new Date(last_seen);
        const diff = Math.abs(last_date - now);

        switch (status) {
            case 'All':
                return true;
            case 'Online':
                return diff < 60000;
            case 'Offline':
                return diff >= 60000;
            default:
                return false
        }
    }

    const getFilteredVehicles = () => {
        if (!vehicles) return []
        return sortBy(vehicles.filter(vehicle => checkOnlineStatus(vehicle.status_datetime, filter)), (obj) => obj.serial_number)
    }

    // eslint-disable-next-line
    useEffect(() => {
        if (!loggedIn) {
            navigate(LOGIN_PAGE)
        } else {
            dispatch(getVehicles(selectedUnitID))
                .then((response) => {
                    if (response.payload === 200) {
                        setLoading(false)
                    }
                })
            const interval = setInterval(() => {
                dispatch(getVehicles(selectedUnitID))
                    .then((response) => {
                        if (response.payload === 200) {
                            setLoading(false)
                        }
                    })
            }, 5000);

            return () => clearInterval(interval);
        }
    }, [loggedIn, selectedUnitID]);

    useEffect(() => {
        if (!!!selectedUnitID && vehicles?.length > 0) {
            let copy = vehicles?.map(v => v)
            copy?.sort((v1, v2) => v1.serial_number > v2.serial_number ? 1 : -1)
            setMapCoord([copy[0].gps_latitude, copy[0].gps_longitude])
        }
        setLoading(vehicles === undefined || vehicles.length === 0);
        // eslint-disable-next-line
    }, [vehicles])

    const onSelectUnit = (v) => { setSelectedUnitID(v.unit_id); setMapCoord([v.gps_latitude, v.gps_longitude]) }
    const onCloseDetail = () => setSelectedUnitID('')

    const filtered = getFilteredVehicles()

    if (isMobile) return (
        <DashboardMobile
            vehicles={filtered}
            selectedUnitID={selectedUnitID} mapCoord={mapCoord} dispatch={dispatch}
            handleMarkerClick={handleMarkerClick} onSelectUnit={onSelectUnit} onCloseDetail={onCloseDetail} />
    )

    return (
        <DashboardDesktop
            vehicles={filtered} selectedUnitID={selectedUnitID} mapCoord={mapCoord} dispatch={dispatch}
            handleMarkerClick={handleMarkerClick} onSelectUnit={onSelectUnit} onCloseDetail={onCloseDetail}
            filter={filter} setFilter={setFilter} />
    )
}

export default Index;
